import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import Tabs from '../tabs';

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
    },
  },
  title: {
    margin: 0,
    paddingRight: theme.spacing(2),
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
      maxWidth: '100%',
      width: '100%',
    },
  },
  tabs: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
}));

const tabOptions = [
  {
    label: 'Profile',
    value: 'profile',
    href: '/account',
  },
  {
    label: 'Account',
    value: 'settings',
    href: '/account/settings',
  },
  {
    label: 'Notifications',
    value: 'notifications',
    href: '/account/notifications',
  },
];

type Props = {
  tab: string;
};

const AccountHeader = ({ tab }: Props) => {
  const { classes } = useStyles();

  return (
    <div className={classes.header}>
      <Typography variant="h1" className={classes.title}>
        Account
      </Typography>

      <div className={classes.headerRight}>
        {tabOptions.length > 1 && (
          <Tabs
            options={tabOptions}
            tab={tab}
            className={classes.tabs}
            links
          />
        )}
      </div>
    </div>
  );
};

export default AccountHeader;
